import React, { useMemo } from 'react';
import styles from './UIGameTradeCreatorProposal.module.scss';
import { Avatar } from '../../../common/Avatar/index.ts';
import IconTradeArrowGreen from '@static/images/icon_trade_arrow_green.svg';
import { cardEnumsToCardState } from '../../../utils/cards.ts';
import { UIGameCardInventory } from '../../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import { LobbyImage } from '@colonist/types';
import { TradeErrorHighlightLocationEnum } from '@colonist/game-mechanic-validators';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useCardsToHighlight } from '../useCardsToHighlight.ts';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
export const UIGameTradeCreatorProposalWantedHalf = ({ wantedCards, onClickWantedCard, isPortraitLayout })=>{
    const gameState = useGameStore((state)=>state.gameState);
    const myColor = useGameStore((state)=>state.myColor);
    const { getPlayerValidator } = usePlayerValidators();
    const currentStateValidator = useCurrentStateValidator();
    const isMyTurn = currentStateValidator.currentTurnPlayers.includes(myColor);
    const isTradeWithAllPlayers = isMyTurn;
    const currentTurnPlayerColor = currentStateValidator.currentTurnPlayers[0];
    const currentTurnPlayerValidator = getPlayerValidator(currentTurnPlayerColor);
    const wantedCardsState = useMemo(()=>cardEnumsToCardState(wantedCards), [
        wantedCards
    ]);
    const cardsToHighlight = useCardsToHighlight(TradeErrorHighlightLocationEnum.ProposalWanted);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.proposalWantedHalfContainer
    }, isTradeWithAllPlayers ? /*#__PURE__*/ React.createElement(Avatar, {
        image: LobbyImage.Players,
        hideBackground: true,
        className: styles.avatar
    }) : /*#__PURE__*/ React.createElement(Avatar, {
        image: currentTurnPlayerValidator.displayIcon,
        color: currentTurnPlayerColor,
        profilePictureUrl: currentTurnPlayerValidator.profilePictureUrl,
        className: styles.avatar
    }), /*#__PURE__*/ React.createElement("img", {
        src: IconTradeArrowGreen,
        className: styles.givingArrow
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.cardStackContainer
    }, /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        showTipTitle: false,
        showTipBody: false,
        cardState: wantedCardsState,
        onClickCard: onClickWantedCard,
        animate: true,
        enablePartition: true,
        className: styles.cardStack,
        cardSize: isPortraitLayout ? 'sm' : 'base',
        cardsToHighlight: cardsToHighlight
    })));
};
